import React from 'react';

import { LuminaSectionElement } from '../element/lumina-section-element';

import type { SectionProps } from './types';

const REQUIRED_ELEMENTS_COUNT = 1;

export const OneColumnSection = ({
	elements,
	isFoldable = false,
}: SectionProps): React.JSX.Element | null => {
	if (elements.length < REQUIRED_ELEMENTS_COUNT) {
		return null;
	}

	return (
		<LuminaSectionElement
			component={elements[0]}
			position="single-column"
			isFoldable={isFoldable}
		/>
	);
};
